"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImplementationGuide = void 0;
/**
 * A set of rules of how a particular interoperability or standards problem is solved - typically through the use of FHIR resources. This resource is used to gather all the parts of an implementation guide into a logical whole and to publish a computable definition of all the parts.
 */
var ImplementationGuide = /** @class */ (function () {
    function ImplementationGuide() {
    }
    return ImplementationGuide;
}());
exports.ImplementationGuide = ImplementationGuide;
(function (ImplementationGuide) {
    ImplementationGuide.StatusEnum = {
        Draft: 'draft',
        Active: 'active',
        Retired: 'retired',
        Unknown: 'unknown'
    };
    ImplementationGuide.LicenseEnum = {
        NotOpenSource: 'not-open-source',
        _0BSD: '0BSD',
        AAL: 'AAL',
        Abstyles: 'Abstyles',
        Adobe2006: 'Adobe-2006',
        AdobeGlyph: 'Adobe-Glyph',
        ADSL: 'ADSL',
        AFL11: 'AFL-1.1',
        AFL12: 'AFL-1.2',
        AFL20: 'AFL-2.0',
        AFL21: 'AFL-2.1',
        AFL30: 'AFL-3.0',
        Afmparse: 'Afmparse',
        AGPL10Only: 'AGPL-1.0-only',
        AGPL10OrLater: 'AGPL-1.0-or-later',
        AGPL30Only: 'AGPL-3.0-only',
        AGPL30OrLater: 'AGPL-3.0-or-later',
        Aladdin: 'Aladdin',
        AMDPLPA: 'AMDPLPA',
        AML: 'AML',
        AMPAS: 'AMPAS',
        ANTLRPD: 'ANTLR-PD',
        Apache10: 'Apache-1.0',
        Apache11: 'Apache-1.1',
        Apache20: 'Apache-2.0',
        APAFML: 'APAFML',
        APL10: 'APL-1.0',
        APSL10: 'APSL-1.0',
        APSL11: 'APSL-1.1',
        APSL12: 'APSL-1.2',
        APSL20: 'APSL-2.0',
        Artistic10Cl8: 'Artistic-1.0-cl8',
        Artistic10Perl: 'Artistic-1.0-Perl',
        Artistic10: 'Artistic-1.0',
        Artistic20: 'Artistic-2.0',
        Bahyph: 'Bahyph',
        Barr: 'Barr',
        Beerware: 'Beerware',
        BitTorrent10: 'BitTorrent-1.0',
        BitTorrent11: 'BitTorrent-1.1',
        Borceux: 'Borceux',
        BSD1Clause: 'BSD-1-Clause',
        BSD2ClauseFreeBSD: 'BSD-2-Clause-FreeBSD',
        BSD2ClauseNetBSD: 'BSD-2-Clause-NetBSD',
        BSD2ClausePatent: 'BSD-2-Clause-Patent',
        BSD2Clause: 'BSD-2-Clause',
        BSD3ClauseAttribution: 'BSD-3-Clause-Attribution',
        BSD3ClauseClear: 'BSD-3-Clause-Clear',
        BSD3ClauseLBNL: 'BSD-3-Clause-LBNL',
        BSD3ClauseNoNuclearLicense2014: 'BSD-3-Clause-No-Nuclear-License-2014',
        BSD3ClauseNoNuclearLicense: 'BSD-3-Clause-No-Nuclear-License',
        BSD3ClauseNoNuclearWarranty: 'BSD-3-Clause-No-Nuclear-Warranty',
        BSD3Clause: 'BSD-3-Clause',
        BSD4ClauseUC: 'BSD-4-Clause-UC',
        BSD4Clause: 'BSD-4-Clause',
        BSDProtection: 'BSD-Protection',
        BSDSourceCode: 'BSD-Source-Code',
        BSL10: 'BSL-1.0',
        Bzip2105: 'bzip2-1.0.5',
        Bzip2106: 'bzip2-1.0.6',
        Caldera: 'Caldera',
        CATOSL11: 'CATOSL-1.1',
        CCBY10: 'CC-BY-1.0',
        CCBY20: 'CC-BY-2.0',
        CCBY25: 'CC-BY-2.5',
        CCBY30: 'CC-BY-3.0',
        CCBY40: 'CC-BY-4.0',
        CCBYNC10: 'CC-BY-NC-1.0',
        CCBYNC20: 'CC-BY-NC-2.0',
        CCBYNC25: 'CC-BY-NC-2.5',
        CCBYNC30: 'CC-BY-NC-3.0',
        CCBYNC40: 'CC-BY-NC-4.0',
        CCBYNCND10: 'CC-BY-NC-ND-1.0',
        CCBYNCND20: 'CC-BY-NC-ND-2.0',
        CCBYNCND25: 'CC-BY-NC-ND-2.5',
        CCBYNCND30: 'CC-BY-NC-ND-3.0',
        CCBYNCND40: 'CC-BY-NC-ND-4.0',
        CCBYNCSA10: 'CC-BY-NC-SA-1.0',
        CCBYNCSA20: 'CC-BY-NC-SA-2.0',
        CCBYNCSA25: 'CC-BY-NC-SA-2.5',
        CCBYNCSA30: 'CC-BY-NC-SA-3.0',
        CCBYNCSA40: 'CC-BY-NC-SA-4.0',
        CCBYND10: 'CC-BY-ND-1.0',
        CCBYND20: 'CC-BY-ND-2.0',
        CCBYND25: 'CC-BY-ND-2.5',
        CCBYND30: 'CC-BY-ND-3.0',
        CCBYND40: 'CC-BY-ND-4.0',
        CCBYSA10: 'CC-BY-SA-1.0',
        CCBYSA20: 'CC-BY-SA-2.0',
        CCBYSA25: 'CC-BY-SA-2.5',
        CCBYSA30: 'CC-BY-SA-3.0',
        CCBYSA40: 'CC-BY-SA-4.0',
        CC010: 'CC0-1.0',
        CDDL10: 'CDDL-1.0',
        CDDL11: 'CDDL-1.1',
        CDLAPermissive10: 'CDLA-Permissive-1.0',
        CDLASharing10: 'CDLA-Sharing-1.0',
        CECILL10: 'CECILL-1.0',
        CECILL11: 'CECILL-1.1',
        CECILL20: 'CECILL-2.0',
        CECILL21: 'CECILL-2.1',
        CECILLB: 'CECILL-B',
        CECILLC: 'CECILL-C',
        ClArtistic: 'ClArtistic',
        CNRIJython: 'CNRI-Jython',
        CNRIPythonGPLCompatible: 'CNRI-Python-GPL-Compatible',
        CNRIPython: 'CNRI-Python',
        Condor11: 'Condor-1.1',
        CPAL10: 'CPAL-1.0',
        CPL10: 'CPL-1.0',
        CPOL102: 'CPOL-1.02',
        Crossword: 'Crossword',
        CrystalStacker: 'CrystalStacker',
        CUAOPL10: 'CUA-OPL-1.0',
        Cube: 'Cube',
        Curl: 'curl',
        DFSL10: 'D-FSL-1.0',
        Diffmark: 'diffmark',
        DOC: 'DOC',
        Dotseqn: 'Dotseqn',
        DSDP: 'DSDP',
        Dvipdfm: 'dvipdfm',
        ECL10: 'ECL-1.0',
        ECL20: 'ECL-2.0',
        EFL10: 'EFL-1.0',
        EFL20: 'EFL-2.0',
        EGenix: 'eGenix',
        Entessa: 'Entessa',
        EPL10: 'EPL-1.0',
        EPL20: 'EPL-2.0',
        ErlPL11: 'ErlPL-1.1',
        EUDatagrid: 'EUDatagrid',
        EUPL10: 'EUPL-1.0',
        EUPL11: 'EUPL-1.1',
        EUPL12: 'EUPL-1.2',
        Eurosym: 'Eurosym',
        Fair: 'Fair',
        Frameworx10: 'Frameworx-1.0',
        FreeImage: 'FreeImage',
        FSFAP: 'FSFAP',
        FSFUL: 'FSFUL',
        FSFULLR: 'FSFULLR',
        FTL: 'FTL',
        GFDL11Only: 'GFDL-1.1-only',
        GFDL11OrLater: 'GFDL-1.1-or-later',
        GFDL12Only: 'GFDL-1.2-only',
        GFDL12OrLater: 'GFDL-1.2-or-later',
        GFDL13Only: 'GFDL-1.3-only',
        GFDL13OrLater: 'GFDL-1.3-or-later',
        Giftware: 'Giftware',
        GL2PS: 'GL2PS',
        Glide: 'Glide',
        Glulxe: 'Glulxe',
        Gnuplot: 'gnuplot',
        GPL10Only: 'GPL-1.0-only',
        GPL10OrLater: 'GPL-1.0-or-later',
        GPL20Only: 'GPL-2.0-only',
        GPL20OrLater: 'GPL-2.0-or-later',
        GPL30Only: 'GPL-3.0-only',
        GPL30OrLater: 'GPL-3.0-or-later',
        GSOAP13b: 'gSOAP-1.3b',
        HaskellReport: 'HaskellReport',
        HPND: 'HPND',
        IBMPibs: 'IBM-pibs',
        ICU: 'ICU',
        IJG: 'IJG',
        ImageMagick: 'ImageMagick',
        IMatix: 'iMatix',
        Imlib2: 'Imlib2',
        InfoZIP: 'Info-ZIP',
        IntelACPI: 'Intel-ACPI',
        Intel: 'Intel',
        Interbase10: 'Interbase-1.0',
        IPA: 'IPA',
        IPL10: 'IPL-1.0',
        ISC: 'ISC',
        JasPer20: 'JasPer-2.0',
        JSON: 'JSON',
        LAL12: 'LAL-1.2',
        LAL13: 'LAL-1.3',
        Latex2e: 'Latex2e',
        Leptonica: 'Leptonica',
        LGPL20Only: 'LGPL-2.0-only',
        LGPL20OrLater: 'LGPL-2.0-or-later',
        LGPL21Only: 'LGPL-2.1-only',
        LGPL21OrLater: 'LGPL-2.1-or-later',
        LGPL30Only: 'LGPL-3.0-only',
        LGPL30OrLater: 'LGPL-3.0-or-later',
        LGPLLR: 'LGPLLR',
        Libpng: 'Libpng',
        Libtiff: 'libtiff',
        LiLiQP11: 'LiLiQ-P-1.1',
        LiLiQR11: 'LiLiQ-R-1.1',
        LiLiQRplus11: 'LiLiQ-Rplus-1.1',
        LinuxOpenIB: 'Linux-OpenIB',
        LPL10: 'LPL-1.0',
        LPL102: 'LPL-1.02',
        LPPL10: 'LPPL-1.0',
        LPPL11: 'LPPL-1.1',
        LPPL12: 'LPPL-1.2',
        LPPL13a: 'LPPL-1.3a',
        LPPL13c: 'LPPL-1.3c',
        MakeIndex: 'MakeIndex',
        MirOS: 'MirOS',
        MIT0: 'MIT-0',
        MITAdvertising: 'MIT-advertising',
        MITCMU: 'MIT-CMU',
        MITEnna: 'MIT-enna',
        MITFeh: 'MIT-feh',
        MIT: 'MIT',
        MITNFA: 'MITNFA',
        Motosoto: 'Motosoto',
        Mpich2: 'mpich2',
        MPL10: 'MPL-1.0',
        MPL11: 'MPL-1.1',
        MPL20NoCopyleftException: 'MPL-2.0-no-copyleft-exception',
        MPL20: 'MPL-2.0',
        MSPL: 'MS-PL',
        MSRL: 'MS-RL',
        MTLL: 'MTLL',
        Multics: 'Multics',
        Mup: 'Mup',
        NASA13: 'NASA-1.3',
        Naumen: 'Naumen',
        NBPL10: 'NBPL-1.0',
        NCSA: 'NCSA',
        NetSNMP: 'Net-SNMP',
        NetCDF: 'NetCDF',
        Newsletr: 'Newsletr',
        NGPL: 'NGPL',
        NLOD10: 'NLOD-1.0',
        NLPL: 'NLPL',
        Nokia: 'Nokia',
        NOSL: 'NOSL',
        Noweb: 'Noweb',
        NPL10: 'NPL-1.0',
        NPL11: 'NPL-1.1',
        NPOSL30: 'NPOSL-3.0',
        NRL: 'NRL',
        NTP: 'NTP',
        OCCTPL: 'OCCT-PL',
        OCLC20: 'OCLC-2.0',
        ODbL10: 'ODbL-1.0',
        OFL10: 'OFL-1.0',
        OFL11: 'OFL-1.1',
        OGTSL: 'OGTSL',
        OLDAP11: 'OLDAP-1.1',
        OLDAP12: 'OLDAP-1.2',
        OLDAP13: 'OLDAP-1.3',
        OLDAP14: 'OLDAP-1.4',
        OLDAP201: 'OLDAP-2.0.1',
        OLDAP20: 'OLDAP-2.0',
        OLDAP21: 'OLDAP-2.1',
        OLDAP221: 'OLDAP-2.2.1',
        OLDAP222: 'OLDAP-2.2.2',
        OLDAP22: 'OLDAP-2.2',
        OLDAP23: 'OLDAP-2.3',
        OLDAP24: 'OLDAP-2.4',
        OLDAP25: 'OLDAP-2.5',
        OLDAP26: 'OLDAP-2.6',
        OLDAP27: 'OLDAP-2.7',
        OLDAP28: 'OLDAP-2.8',
        OML: 'OML',
        OpenSSL: 'OpenSSL',
        OPL10: 'OPL-1.0',
        OSETPL21: 'OSET-PL-2.1',
        OSL10: 'OSL-1.0',
        OSL11: 'OSL-1.1',
        OSL20: 'OSL-2.0',
        OSL21: 'OSL-2.1',
        OSL30: 'OSL-3.0',
        PDDL10: 'PDDL-1.0',
        PHP30: 'PHP-3.0',
        PHP301: 'PHP-3.01',
        Plexus: 'Plexus',
        PostgreSQL: 'PostgreSQL',
        Psfrag: 'psfrag',
        Psutils: 'psutils',
        Python20: 'Python-2.0',
        Qhull: 'Qhull',
        QPL10: 'QPL-1.0',
        Rdisc: 'Rdisc',
        RHeCos11: 'RHeCos-1.1',
        RPL11: 'RPL-1.1',
        RPL15: 'RPL-1.5',
        RPSL10: 'RPSL-1.0',
        RSAMD: 'RSA-MD',
        RSCPL: 'RSCPL',
        Ruby: 'Ruby',
        SAXPD: 'SAX-PD',
        Saxpath: 'Saxpath',
        SCEA: 'SCEA',
        Sendmail: 'Sendmail',
        SGIB10: 'SGI-B-1.0',
        SGIB11: 'SGI-B-1.1',
        SGIB20: 'SGI-B-2.0',
        SimPL20: 'SimPL-2.0',
        SISSL12: 'SISSL-1.2',
        SISSL: 'SISSL',
        Sleepycat: 'Sleepycat',
        SMLNJ: 'SMLNJ',
        SMPPL: 'SMPPL',
        SNIA: 'SNIA',
        Spencer86: 'Spencer-86',
        Spencer94: 'Spencer-94',
        Spencer99: 'Spencer-99',
        SPL10: 'SPL-1.0',
        SugarCRM113: 'SugarCRM-1.1.3',
        SWL: 'SWL',
        TCL: 'TCL',
        TCPWrappers: 'TCP-wrappers',
        TMate: 'TMate',
        TORQUE11: 'TORQUE-1.1',
        TOSL: 'TOSL',
        UnicodeDFS2015: 'Unicode-DFS-2015',
        UnicodeDFS2016: 'Unicode-DFS-2016',
        UnicodeTOU: 'Unicode-TOU',
        Unlicense: 'Unlicense',
        UPL10: 'UPL-1.0',
        Vim: 'Vim',
        VOSTROM: 'VOSTROM',
        VSL10: 'VSL-1.0',
        W3C19980720: 'W3C-19980720',
        W3C20150513: 'W3C-20150513',
        W3C: 'W3C',
        Watcom10: 'Watcom-1.0',
        Wsuipa: 'Wsuipa',
        WTFPL: 'WTFPL',
        X11: 'X11',
        Xerox: 'Xerox',
        XFree8611: 'XFree86-1.1',
        Xinetd: 'xinetd',
        Xnet: 'Xnet',
        Xpp: 'xpp',
        XSkat: 'XSkat',
        YPL10: 'YPL-1.0',
        YPL11: 'YPL-1.1',
        Zed: 'Zed',
        Zend20: 'Zend-2.0',
        Zimbra13: 'Zimbra-1.3',
        Zimbra14: 'Zimbra-1.4',
        ZlibAcknowledgement: 'zlib-acknowledgement',
        Zlib: 'Zlib',
        ZPL11: 'ZPL-1.1',
        ZPL20: 'ZPL-2.0',
        ZPL21: 'ZPL-2.1'
    };
})(ImplementationGuide = exports.ImplementationGuide || (exports.ImplementationGuide = {}));
exports.ImplementationGuide = ImplementationGuide;
